import { render, staticRenderFns } from "./email_notifications.vue?vue&type=template&id=ae6d2cd8&scoped=true&"
import script from "./email_notifications.vue?vue&type=script&lang=js&"
export * from "./email_notifications.vue?vue&type=script&lang=js&"
import style0 from "./email_notifications.vue?vue&type=style&index=0&id=ae6d2cd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae6d2cd8",
  null
  
)

export default component.exports